
import Vue from 'vue'

export default Vue.extend({
  name: 'BigArrowSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
